
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $dA1Sn = parcelRequire("dA1Sn");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");





var $9wGTI = parcelRequire("9wGTI");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");




/**
 * @generated SignedSource<<8123d4d752ec36317e81af577d546915>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72
const $6900e8f8fbd4b479$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
            "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
            "metadata": {},
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$6900e8f8fbd4b479$var$node.hash = "cbad882df31b75e4699e60f1bcf2ae8b";
var $6900e8f8fbd4b479$export$2e2bcd8739ae039 = $6900e8f8fbd4b479$var$node;






var $kNIYN = parcelRequire("kNIYN");


var $iMnC5 = parcelRequire("iMnC5");


var $laFNM = parcelRequire("laFNM");


var $63EIj = parcelRequire("63EIj");


var $jkVM2 = parcelRequire("jkVM2");


var $bJX6u = parcelRequire("bJX6u");





var $7om8k = parcelRequire("7om8k");


var $7QM6o = parcelRequire("7QM6o");





var $8Psje = parcelRequire("8Psje");





var $kSwu1 = parcelRequire("kSwu1");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $b35Wv = parcelRequire("b35Wv");


var $3FlVr = parcelRequire("3FlVr");


var $83sfO = parcelRequire("83sfO");





var $1NF8X = parcelRequire("1NF8X");

const $06f66a283e23582e$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$floatingContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px',
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)(); // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $06f66a283e23582e$var$floatingContainerStyles,
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $3FlVr.ReactionLocation).BLOGPOST : (0, $3FlVr.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: true,
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        readOnly: isDisabled,
        isViewOnly: isDisabled,
        isSubtle: true,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: formatMessage($06f66a283e23582e$var$i18n.addNew),
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: true,
        noFlexWrap: true,
        hoverableSummaryView: true,
        optimisticallyLoadSummaryEmojis: isSSR,
        renderParticleEffectOnSummaryView: true
    }));
};



var $fImWv = parcelRequire("fImWv");


var $04VgG = parcelRequire("04VgG");





var $5vi32 = parcelRequire("5vi32");








var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $8h2Hn = parcelRequire("8h2Hn");


var $LSims = parcelRequire("LSims");


var $aKxcs = parcelRequire("aKxcs");


var $6iOCg = parcelRequire("6iOCg");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(80);
    const { contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy, spaceName: spaceName, classificationContextFragmentRef: classificationContextFragmentRef } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    let t1;
    if ($[0] !== spaceKey) {
        t1 = (0, $8Psje.isRovoSystemSpaceKey)(spaceKey);
        $[0] = spaceKey;
        $[1] = t1;
    } else t1 = $[1];
    const isRovoSystemSpace = t1;
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const { approvalRequest: approvalRequest, availableWorkflowStatuses: availableWorkflowStatuses } = (0, $laFNM.useApprovals)();
    let t2;
    if ($[2] !== approvalRequest || $[3] !== availableWorkflowStatuses) {
        t2 = !!approvalRequest?.application?.workflowStatusId && availableWorkflowStatuses.some((s)=>s.id === approvalRequest.application.workflowStatusId) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[2] = approvalRequest;
        $[3] = availableWorkflowStatuses;
        $[4] = t2;
    } else t2 = $[4];
    const hasActiveWorkflowStatus = t2;
    const { isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t3;
    if ($[5] !== contentId) {
        t3 = {
            fetchPolicy: "cache-first",
            variables: {
                contentId: contentId,
                isDraft: true
            },
            skip: !window.__SSR_RENDERED__
        };
        $[5] = contentId;
        $[6] = t3;
    } else t3 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), {
        ...t3,
        __callerPackage__: "content-header"
    });
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    let t4;
    if ($[7] !== generatedBy || $[8] !== isRovoSystemSpace) {
        t4 = isRovoSystemSpace && generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence-ai-planner-hide-reaction");
        $[7] = generatedBy;
        $[8] = isRovoSystemSpace;
        $[9] = t4;
    } else t4 = $[9];
    const shouldHideReactionsInRovoStaging = t4;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions && !shouldHideReactionsInRovoStaging;
    const t5 = renderReactions ? undefined : "space.050";
    let t6;
    if ($[10] !== author || $[11] !== contributorCountWithoutOwner || $[12] !== generatedBy || $[13] !== owner) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "liveDoc",
            contributorCountWithoutOwner: contributorCountWithoutOwner,
            generatedBy: generatedBy
        });
        $[10] = author;
        $[11] = contributorCountWithoutOwner;
        $[12] = generatedBy;
        $[13] = owner;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: t5
        }, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const singleLineOwnershipByline = t7;
    const shouldHideMarkdownModeOptions = isMarkdownMode;
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    const showThirdPartyByLineExtensions = showByLineExtensions && !shouldHideMarkdownModeOptions;
    let t8;
    if ($[18] !== generatedBy) {
        t8 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline");
        $[18] = generatedBy;
        $[19] = t8;
    } else t8 = $[19];
    const shouldRenderAIPlannerSyncByline = t8;
    let t9;
    if ($[20] !== classificationContextFragmentRef || $[21] !== contentId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId,
            classificationContextFragmentRef: classificationContextFragmentRef
        });
        $[20] = classificationContextFragmentRef;
        $[21] = contentId;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== contentId || $[25] !== contentType || $[26] !== data?.singleContent?.contentState || $[27] !== hasActiveWorkflowStatus || $[28] !== isKnowledgeBaseSpace || $[29] !== isLivePage || $[30] !== isPublishingContent || $[31] !== userOffline || $[32] !== viewMode) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t10
        }, (contentStateState)=>{
            if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63EIj.RendererContentState), {
                contentId: contentId,
                hasSeparator: false,
                isDraft: !isLivePage
            });
            const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
            if (contentStateState.state.contentState || hasActiveWorkflowStatus || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                floatingToolbarButtonStyle: {
                    alignItems: "center",
                    height: "24px"
                },
                isViewMode: viewMode ?? false
            });
            else return null;
        });
        $[24] = contentId;
        $[25] = contentType;
        $[26] = data?.singleContent?.contentState;
        $[27] = hasActiveWorkflowStatus;
        $[28] = isKnowledgeBaseSpace;
        $[29] = isLivePage;
        $[30] = isPublishingContent;
        $[31] = userOffline;
        $[32] = viewMode;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== contentId || $[35] !== editorApi || $[36] !== shouldHideMarkdownModeOptions) {
        t12 = !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: true
        });
        $[34] = contentId;
        $[35] = editorApi;
        $[36] = shouldHideMarkdownModeOptions;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== contentId) {
        t13 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8h2Hn.BylineConnections), {
            contentId: contentId
        });
        $[38] = contentId;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== contentId || $[41] !== contentType || $[42] !== isAudioBylineEntrypointEnabled || $[43] !== shouldHideMarkdownModeOptions) {
        t14 = isAudioBylineEntrypointEnabled && !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType
        });
        $[40] = contentId;
        $[41] = contentType;
        $[42] = isAudioBylineEntrypointEnabled;
        $[43] = shouldHideMarkdownModeOptions;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== author || $[46] !== contentId || $[47] !== isLivePage || $[48] !== isUnpublishedDraft) {
        t15 = (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        });
        $[45] = author;
        $[46] = contentId;
        $[47] = isLivePage;
        $[48] = isUnpublishedDraft;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t15 || $[55] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t11, t12, t13, t14, t15);
        $[50] = t11;
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
        $[54] = t15;
        $[55] = t9;
        $[56] = t16;
    } else t16 = $[56];
    const byLineExtensions = t16;
    const t17 = showByLineExtensions && byLineExtensions;
    let t18;
    if ($[57] !== contentId || $[58] !== contentType || $[59] !== renderReactions || $[60] !== spaceId || $[61] !== userOffline) {
        t18 = renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
            contentId: contentId,
            spaceId: spaceId || "",
            isDisabled: userOffline,
            contentType: contentType
        });
        $[57] = contentId;
        $[58] = contentType;
        $[59] = renderReactions;
        $[60] = spaceId;
        $[61] = userOffline;
        $[62] = t18;
    } else t18 = $[62];
    let t19;
    if ($[63] !== t17 || $[64] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t17, t18);
        $[63] = t17;
        $[64] = t18;
        $[65] = t19;
    } else t19 = $[65];
    const ByLineCommonContent = t19;
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    const t20 = contentType;
    const t21 = showByLineContributors && singleLineOwnershipByline;
    let t22;
    if ($[66] !== contentId || $[67] !== contentType || $[68] !== generatedBy || $[69] !== isEmbeddedConfluence || $[70] !== shouldRenderAIPlannerSyncByline || $[71] !== spaceName) {
        t22 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence,
            spaceName: spaceName
        });
        $[66] = contentId;
        $[67] = contentType;
        $[68] = generatedBy;
        $[69] = isEmbeddedConfluence;
        $[70] = shouldRenderAIPlannerSyncByline;
        $[71] = spaceName;
        $[72] = t22;
    } else t22 = $[72];
    let t23;
    if ($[73] !== ByLineCommonContent || $[74] !== contentId || $[75] !== showThirdPartyByLineExtensions || $[76] !== t20 || $[77] !== t21 || $[78] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            contentType: t20,
            showByLineExtensions: showThirdPartyByLineExtensions
        }, t21, t22, ByLineCommonContent);
        $[73] = ByLineCommonContent;
        $[74] = contentId;
        $[75] = showThirdPartyByLineExtensions;
        $[76] = t20;
        $[77] = t21;
        $[78] = t22;
        $[79] = t23;
    } else t23 = $[79];
    return t23;
});



var $ausiN = parcelRequire("ausiN");


var $83fWZ = parcelRequire("83fWZ");

const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $cozmU.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
            includeDevDocsBylineConnection: !isLivePage && (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs'),
            includeClassification: (0, $9wGTI.fg)('confluence_vp_classification_context_frag_reader'),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "content-header"
    });
    const renderByLine = ()=>{
        // HACK: status: ['draft'] for unpublished drafts results in a weird case where loading is true and we also have the data. Need to investigate this further, but this hack should work for now.
        // happens because isUnpublishedDraft goes from false to true during SSR. ideally we would either always get the right data, or not need it (pass status: ['draft', 'current'] all the time - which could cause caching issues)
        const hasSSRData = renderServerPlaceholder && Boolean(data);
        if (loading && !hasSSRData) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3db5129918072e70$export$a6a69f624b6c8259), {
            ...contributorProps,
            contentId: contentId,
            classificationContextFragmentRef: content.bylineClassificationFragment,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    const generatedBy = content?.contentProperties?.latest?.generatedBy;
    const spaceName = content?.space?.name?.trim() || null;
    return {
        author: author,
        owner: owner,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        generatedBy: generatedBy,
        spaceName: spaceName
    };
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    if (isSpaceOverview) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("cc_editor_two_stage_hydration_removal", "editorByLineArea", true);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== contentType || $[3] !== editorApi || $[4] !== hasByLineContributors || $[5] !== hasByLineExtensions || $[6] !== hasReactions || $[7] !== isKnowledgeBaseSpace || $[8] !== isPublishingContent || $[9] !== isUnpublishedDraft || $[10] !== userOffline || $[11] !== viewMode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            viewMode: viewMode,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions
        });
        $[1] = contentId;
        $[2] = contentType;
        $[3] = editorApi;
        $[4] = hasByLineContributors;
        $[5] = hasByLineExtensions;
        $[6] = hasReactions;
        $[7] = isKnowledgeBaseSpace;
        $[8] = isPublishingContent;
        $[9] = isUnpublishedDraft;
        $[10] = userOffline;
        $[11] = viewMode;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== ssrPlaceholderIdProp || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "editor-byline",
            enabled: !t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
            "data-vc": "editor-byline-wrapper",
            ...ssrPlaceholderIdProp
        }, t2));
        $[13] = ssrPlaceholderIdProp;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
module.exports["EditorByLineArea"] = $d54487d18f54cde1$export$a5fad03eb2e226dc;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("6dfkC"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("6dfkC", function(module, exports) {

let $485fd97ccf08a985$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $485fd97ccf08a985$var$load("dgerE"),
    $485fd97ccf08a985$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("9ndkG"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("9ndkG", function(module, exports) {

let $01c2d9340c4c4abe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $01c2d9340c4c4abe$var$load("dgerE"),
    $01c2d9340c4c4abe$var$load("el56J"),
    $01c2d9340c4c4abe$var$load("hhss7"),
    $01c2d9340c4c4abe$var$load("9cpj1"),
    $01c2d9340c4c4abe$var$load("aC3bY"),
    $01c2d9340c4c4abe$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("7om8k", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hNRe4 = parcelRequire("hNRe4");

const $a7795cfffaaaa1a7$export$a976a35f73cf7a61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
};
module.exports["BadgeStylePageOwnershipByline"] = $a7795cfffaaaa1a7$export$a976a35f73cf7a61;

});

parcelRegister("hNRe4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $lpNn5 = parcelRequire("lpNn5");


var $4n1IT = parcelRequire("4n1IT");


var $kz1Yj = parcelRequire("kz1Yj");


var $6Pqow = parcelRequire("6Pqow");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $eToX6 = parcelRequire("eToX6");


var $kuujH = parcelRequire("kuujH");


var $jFm04 = parcelRequire("jFm04");


var $2zphh = parcelRequire("2zphh");


var $iMxJy = parcelRequire("iMxJy");


const $a1b50edf1fd86d1e$var$LazyPopupContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Qz_k",
    name: "LazyPopupContent",
    loader: async ()=>(await (parcelRequire("cFBoN"))).PageOwnershipByLineWithContributorsDropdownContent
});
const $a1b50edf1fd86d1e$var$triggerStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1b50edf1fd86d1e$var$smartFolderHeaderTriggerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'radius.small',
    minHeight: 'space.300',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1b50edf1fd86d1e$var$previewPanelCardStyle = (0, $buxP3.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal'
});
const $a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent = ({ owner: owner, author: author, contributorCountWithoutOwner: contributorCountWithoutOwner, analyticsSource: analyticsSource, generatedBy: generatedBy, isSmartFolderHeaderByline: isSmartFolderHeaderByline = false, shouldRenderToParent: shouldRenderToParentProp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { openModal: openChangeOwnerModal } = (0, $jFm04.useContentOwnershipContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const [triggerRefDuplicate, setTriggerRefDuplicate] = (0, $cozmU.useState)(null);
    const createDuplicateRef = (0, $iMxJy.useDuplicateRef)();
    // Tracks whether the dropdown was explicitly opened by a click (pinned open).
    // When pinned, the dropdown stays open even when the mouse leaves.
    const isPinnedRef = (0, $cozmU.useRef)(false);
    // Reset state when changing contentId
    (0, $cozmU.useEffect)(()=>{
        setIsDropdownOpen(false);
        isPinnedRef.current = false;
    }, [
        contentId
    ]);
    const pageOwner = owner ?? author;
    const avatarSrc = (0, $2zphh.getUserAvatarSrc)(pageOwner);
    const profileCardResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    const onPopupTriggerClick = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) {
            if (isDropdownOpen && !isPinnedRef.current) // Menu is open from hover — pin it open instead of closing
            isPinnedRef.current = true;
            else {
                // Closed → open and pin, or pinned → close and unpin
                const next = !isDropdownOpen;
                isPinnedRef.current = next;
                setIsDropdownOpen(next);
            }
        } else // Control path: simple toggle without pinning
        setIsDropdownOpen((prev)=>!prev);
    }, [
        isDropdownOpen
    ]);
    // Hover-to-open logic: when cc_show_byline_job_title experiment is enabled,
    // the dropdown opens on hover instead of requiring a click (tooltip is also hidden).
    // A 200ms delay on mouse leave prevents the dropdown from closing while the user
    // moves their cursor from the trigger to the popup content.
    const hoverCloseTimeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clearHoverCloseTimeout();
    }, []);
    const clearHoverCloseTimeout = ()=>{
        if (hoverCloseTimeoutRef.current) {
            clearTimeout(hoverCloseTimeoutRef.current);
            hoverCloseTimeoutRef.current = null;
        }
    };
    const startHoverCloseTimeout = ()=>{
        clearHoverCloseTimeout();
        hoverCloseTimeoutRef.current = setTimeout(()=>{
            setIsDropdownOpen(false);
        }, 200);
    };
    const onPopupTriggerMouseEnter = ()=>{
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) {
            clearHoverCloseTimeout();
            setIsDropdownOpen(true);
        }
    };
    const onPopupTriggerMouseLeave = ()=>{
        if (!isPinnedRef.current && (0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) startHoverCloseTimeout();
    };
    const onPopupContentMouseEnter = ()=>{
        clearHoverCloseTimeout();
    };
    const onPopupContentMouseLeave = ()=>{
        if (!isPinnedRef.current && (0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) startHoverCloseTimeout();
    };
    const onPopupClose = (0, $cozmU.useCallback)(()=>{
        clearHoverCloseTimeout();
        isPinnedRef.current = false;
        setIsDropdownOpen(false);
    }, []);
    const onChangeOwnerClick = (0, $cozmU.useCallback)(()=>{
        // accessibility: return focus to dropdown trigger when change owner modal closes - doesnt happen automatically because the change owner modal trigger is in the dropdown which gets unmounted when the modal opens.
        openChangeOwnerModal({
            returnFocusRef: triggerRefDuplicate ?? undefined
        });
        setIsDropdownOpen(false);
    }, [
        openChangeOwnerModal,
        triggerRefDuplicate
    ]);
    const ownerInfoInsidePreviewPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $a1b50edf1fd86d1e$var$previewPanelCardStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarSrc,
        borderColor: "transparent",
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
        user: pageOwner.fullName
    })));
    const popupTrigger = ({ ref: ref, ...triggerProps })=>{
        const triggerRef = createDuplicateRef(ref, setTriggerRefDuplicate);
        const pressable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            testId: "owner-with-contributors-dropdown-trigger",
            xcss: isSmartFolderHeaderByline ? $a1b50edf1fd86d1e$var$smartFolderHeaderTriggerStyles : $a1b50edf1fd86d1e$var$triggerStyles,
            onClick: onPopupTriggerClick,
            onMouseEnter: onPopupTriggerMouseEnter,
            onMouseLeave: onPopupTriggerMouseLeave,
            ref: triggerRef,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            borderColor: "transparent",
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
            user: pageOwner.fullName
        }))));
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) return pressable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: isDropdownOpen ? undefined : intl.formatMessage(analyticsSource.startsWith('folder') ? (0, $kuujH.i18n).ownerDropdownTooltip : (0, $kuujH.i18n).ownerWithContributorsDropdownTooltip),
            position: "bottom",
            hideTooltipOnClick: true
        }, pressable);
    };
    if (profileCardResidesInPreviewPanel) return ownerInfoInsidePreviewPanel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                role: "presentation",
                onMouseEnter: onPopupContentMouseEnter,
                onMouseLeave: onPopupContentMouseLeave,
                onFocus: onPopupContentMouseEnter,
                onBlur: onPopupContentMouseLeave
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1b50edf1fd86d1e$var$LazyPopupContent, {
                analyticsSource: `${analyticsSource}-byline`,
                owner: pageOwner,
                onChangeOwnerClick: onChangeOwnerClick,
                contributorCountWithoutOwner: contributorCountWithoutOwner
            })),
        trigger: popupTrigger,
        isOpen: isDropdownOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParentProp !== undefined ? shouldRenderToParentProp : (0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true)
    });
};
const $a1b50edf1fd86d1e$export$4f664a3a9881436 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})((0, $jFm04.withContentOwnershipContextProvider)($a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent));
module.exports["PageOwnershipByLineWithContributorsDropdown"] = $a1b50edf1fd86d1e$export$4f664a3a9881436;

});

parcelRegister("2zphh", function(module, exports) {
const $bf70d92172ad781d$export$eae7710ac4f92e1b = (user)=>{
    return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
module.exports["getUserAvatarSrc"] = $bf70d92172ad781d$export$eae7710ac4f92e1b;

});

parcelRegister("iMxJy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");

const $de8876e797e08e86$export$376d7d7a8afb5e40 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)($de8876e797e08e86$var$_temp2);
    return createDuplicateRef;
} : ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)(()=>(0, $dOBRD.default)((ref, setDuplicatedRef)=>{
            return (node)=>{
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                setDuplicatedRef({
                    current: node
                });
            };
        }));
    return createDuplicateRef;
};
function $de8876e797e08e86$var$_temp(ref, setDuplicatedRef) {
    return (node)=>{
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
        setDuplicatedRef({
            current: node
        });
    };
}
function $de8876e797e08e86$var$_temp2() {
    return (0, $dOBRD.default)($de8876e797e08e86$var$_temp);
}
module.exports["useDuplicateRef"] = $de8876e797e08e86$export$376d7d7a8afb5e40;

});

parcelRegister("cFBoN", function(module, exports) {

let $939653086c9f003d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $939653086c9f003d$var$load("3tHBV"),
    $939653086c9f003d$var$load("cWvhX")
]).then(()=>parcelRequire('8M3ga'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("DuBnA"))).ReadTime
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("DuBnA", function(module, exports) {

let $076b618838d2874a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $076b618838d2874a$var$load("kIOif"),
    $076b618838d2874a$var$load("irgIM")
]).then(()=>parcelRequire('cbZqw'));

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !(isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled')) && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116487cb0b813d32319987cd91f03acd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_baseNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6311da47ce726fc7626619a6b7c14fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_baseNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("gElAV")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("aZ9If", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eccf7d66f35470272dc64714274958f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff722a3b4d1cbe6$var$_react = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7ff722a3b4d1cbe6$var$_baseNew = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7ff722a3b4d1cbe6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TeamworkGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/teamwork-graph
 * Usage guidance:
 * Reserved for Teamwork Graph features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff722a3b4d1cbe6$var$TeamworkGraphIcon = (props)=>/*#__PURE__*/ $7ff722a3b4d1cbe6$var$_react.default.createElement($7ff722a3b4d1cbe6$var$_baseNew.default, Object.assign({
        name: "TeamworkGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 12.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m8.5 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m0-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m-7 8.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-1.5-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0c0 .61-.169 1.18-.46 1.668l4.04 4.042a3.25 3.25 0 1 1-1.074 1.047L5.492 6.492A3.25 3.25 0 1 1 7 3.75m8.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$7ff722a3b4d1cbe6$var$TeamworkGraphIcon.displayName = 'TeamworkGraphIcon';
var $7ff722a3b4d1cbe6$var$_default = module.exports.default = $7ff722a3b4d1cbe6$var$TeamworkGraphIcon;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("6GvGD"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("hYkrv"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("c19Bu"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("h0PPQ"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("khyJi"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("aDqK1"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("5a0IY"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("1udyT"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2PFxD"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("du0t7"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("jBfC3"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("bydAg"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("6GvGD", function(module, exports) {

let $4ddf3e9f1bf0b5d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ddf3e9f1bf0b5d2$var$load("hUbK8"),
    $4ddf3e9f1bf0b5d2$var$load("LWh5V"),
    $4ddf3e9f1bf0b5d2$var$load("eNXrl"),
    $4ddf3e9f1bf0b5d2$var$load("2RkKX"),
    $4ddf3e9f1bf0b5d2$var$load("dZsGY"),
    $4ddf3e9f1bf0b5d2$var$load("1Gr4q"),
    $4ddf3e9f1bf0b5d2$var$load("hLNtE"),
    $4ddf3e9f1bf0b5d2$var$load("crwC4"),
    $4ddf3e9f1bf0b5d2$var$load("7G12e"),
    $4ddf3e9f1bf0b5d2$var$load("h4Nf7"),
    $4ddf3e9f1bf0b5d2$var$load("123MJ"),
    $4ddf3e9f1bf0b5d2$var$load("elQ9h"),
    $4ddf3e9f1bf0b5d2$var$load("4XoWv"),
    $4ddf3e9f1bf0b5d2$var$load("59hV4"),
    $4ddf3e9f1bf0b5d2$var$load("cFgVe"),
    $4ddf3e9f1bf0b5d2$var$load("5wzAc"),
    $4ddf3e9f1bf0b5d2$var$load("aLwQm"),
    $4ddf3e9f1bf0b5d2$var$load("gBfQ7"),
    $4ddf3e9f1bf0b5d2$var$load("eTvQu"),
    $4ddf3e9f1bf0b5d2$var$load("dr883"),
    $4ddf3e9f1bf0b5d2$var$load("bePXd"),
    $4ddf3e9f1bf0b5d2$var$load("kHXvF"),
    $4ddf3e9f1bf0b5d2$var$load("ea3NB"),
    $4ddf3e9f1bf0b5d2$var$load("kv4Kv"),
    $4ddf3e9f1bf0b5d2$var$load("qCaIx"),
    $4ddf3e9f1bf0b5d2$var$load("fuOfV"),
    $4ddf3e9f1bf0b5d2$var$load("jL1Ke"),
    $4ddf3e9f1bf0b5d2$var$load("5MQ0D"),
    $4ddf3e9f1bf0b5d2$var$load("exBMi"),
    $4ddf3e9f1bf0b5d2$var$load("6vqGz"),
    $4ddf3e9f1bf0b5d2$var$load("iBJWz"),
    $4ddf3e9f1bf0b5d2$var$load("cvcNg"),
    $4ddf3e9f1bf0b5d2$var$load("iZR3N"),
    $4ddf3e9f1bf0b5d2$var$load("jXM1T"),
    $4ddf3e9f1bf0b5d2$var$load("6wr18"),
    $4ddf3e9f1bf0b5d2$var$load("4N1MY"),
    $4ddf3e9f1bf0b5d2$var$load("ffEVr"),
    $4ddf3e9f1bf0b5d2$var$load("g81ly"),
    $4ddf3e9f1bf0b5d2$var$load("e3LAK"),
    $4ddf3e9f1bf0b5d2$var$load("eS3wT"),
    $4ddf3e9f1bf0b5d2$var$load("4uO8Y"),
    $4ddf3e9f1bf0b5d2$var$load("60QcS"),
    $4ddf3e9f1bf0b5d2$var$load("Wowvf"),
    $4ddf3e9f1bf0b5d2$var$load("2l8zo"),
    $4ddf3e9f1bf0b5d2$var$load("fEWss"),
    $4ddf3e9f1bf0b5d2$var$load("ceGPg"),
    $4ddf3e9f1bf0b5d2$var$load("26l7c"),
    $4ddf3e9f1bf0b5d2$var$load("hhss7"),
    $4ddf3e9f1bf0b5d2$var$load("cgKMu"),
    $4ddf3e9f1bf0b5d2$var$load("lnKog"),
    $4ddf3e9f1bf0b5d2$var$load("aAWLw"),
    $4ddf3e9f1bf0b5d2$var$load("7EorR"),
    $4ddf3e9f1bf0b5d2$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("hYkrv", function(module, exports) {

let $d157e5baca9e8214$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d157e5baca9e8214$var$load("hUbK8"),
    $d157e5baca9e8214$var$load("LWh5V"),
    $d157e5baca9e8214$var$load("eNXrl"),
    $d157e5baca9e8214$var$load("2RkKX"),
    $d157e5baca9e8214$var$load("dZsGY"),
    $d157e5baca9e8214$var$load("1Gr4q"),
    $d157e5baca9e8214$var$load("hLNtE"),
    $d157e5baca9e8214$var$load("crwC4"),
    $d157e5baca9e8214$var$load("7G12e"),
    $d157e5baca9e8214$var$load("h4Nf7"),
    $d157e5baca9e8214$var$load("123MJ"),
    $d157e5baca9e8214$var$load("elQ9h"),
    $d157e5baca9e8214$var$load("4XoWv"),
    $d157e5baca9e8214$var$load("59hV4"),
    $d157e5baca9e8214$var$load("cFgVe"),
    $d157e5baca9e8214$var$load("5wzAc"),
    $d157e5baca9e8214$var$load("aLwQm"),
    $d157e5baca9e8214$var$load("gBfQ7"),
    $d157e5baca9e8214$var$load("eTvQu"),
    $d157e5baca9e8214$var$load("dr883"),
    $d157e5baca9e8214$var$load("bePXd"),
    $d157e5baca9e8214$var$load("kHXvF"),
    $d157e5baca9e8214$var$load("ea3NB"),
    $d157e5baca9e8214$var$load("kv4Kv"),
    $d157e5baca9e8214$var$load("qCaIx"),
    $d157e5baca9e8214$var$load("fuOfV"),
    $d157e5baca9e8214$var$load("jL1Ke"),
    $d157e5baca9e8214$var$load("5MQ0D"),
    $d157e5baca9e8214$var$load("exBMi"),
    $d157e5baca9e8214$var$load("6vqGz"),
    $d157e5baca9e8214$var$load("iBJWz"),
    $d157e5baca9e8214$var$load("cvcNg"),
    $d157e5baca9e8214$var$load("iZR3N"),
    $d157e5baca9e8214$var$load("jXM1T"),
    $d157e5baca9e8214$var$load("6wr18"),
    $d157e5baca9e8214$var$load("4N1MY"),
    $d157e5baca9e8214$var$load("ffEVr"),
    $d157e5baca9e8214$var$load("g81ly"),
    $d157e5baca9e8214$var$load("e3LAK"),
    $d157e5baca9e8214$var$load("eS3wT"),
    $d157e5baca9e8214$var$load("4uO8Y"),
    $d157e5baca9e8214$var$load("60QcS"),
    $d157e5baca9e8214$var$load("Wowvf"),
    $d157e5baca9e8214$var$load("2l8zo"),
    $d157e5baca9e8214$var$load("fEWss"),
    $d157e5baca9e8214$var$load("ceGPg"),
    $d157e5baca9e8214$var$load("26l7c"),
    $d157e5baca9e8214$var$load("hhss7"),
    $d157e5baca9e8214$var$load("cgKMu"),
    $d157e5baca9e8214$var$load("lnKog"),
    $d157e5baca9e8214$var$load("aAWLw"),
    $d157e5baca9e8214$var$load("7EorR"),
    $d157e5baca9e8214$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("c19Bu", function(module, exports) {

let $8bfd07244d38d92b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8bfd07244d38d92b$var$load("hUbK8"),
    $8bfd07244d38d92b$var$load("LWh5V"),
    $8bfd07244d38d92b$var$load("eNXrl"),
    $8bfd07244d38d92b$var$load("2RkKX"),
    $8bfd07244d38d92b$var$load("dZsGY"),
    $8bfd07244d38d92b$var$load("1Gr4q"),
    $8bfd07244d38d92b$var$load("hLNtE"),
    $8bfd07244d38d92b$var$load("crwC4"),
    $8bfd07244d38d92b$var$load("7G12e"),
    $8bfd07244d38d92b$var$load("h4Nf7"),
    $8bfd07244d38d92b$var$load("123MJ"),
    $8bfd07244d38d92b$var$load("elQ9h"),
    $8bfd07244d38d92b$var$load("4XoWv"),
    $8bfd07244d38d92b$var$load("59hV4"),
    $8bfd07244d38d92b$var$load("cFgVe"),
    $8bfd07244d38d92b$var$load("5wzAc"),
    $8bfd07244d38d92b$var$load("aLwQm"),
    $8bfd07244d38d92b$var$load("gBfQ7"),
    $8bfd07244d38d92b$var$load("eTvQu"),
    $8bfd07244d38d92b$var$load("dr883"),
    $8bfd07244d38d92b$var$load("bePXd"),
    $8bfd07244d38d92b$var$load("kHXvF"),
    $8bfd07244d38d92b$var$load("ea3NB"),
    $8bfd07244d38d92b$var$load("kv4Kv"),
    $8bfd07244d38d92b$var$load("qCaIx"),
    $8bfd07244d38d92b$var$load("fuOfV"),
    $8bfd07244d38d92b$var$load("jL1Ke"),
    $8bfd07244d38d92b$var$load("5MQ0D"),
    $8bfd07244d38d92b$var$load("exBMi"),
    $8bfd07244d38d92b$var$load("6vqGz"),
    $8bfd07244d38d92b$var$load("iBJWz"),
    $8bfd07244d38d92b$var$load("cvcNg"),
    $8bfd07244d38d92b$var$load("iZR3N"),
    $8bfd07244d38d92b$var$load("jXM1T"),
    $8bfd07244d38d92b$var$load("6wr18"),
    $8bfd07244d38d92b$var$load("4N1MY"),
    $8bfd07244d38d92b$var$load("ffEVr"),
    $8bfd07244d38d92b$var$load("g81ly"),
    $8bfd07244d38d92b$var$load("e3LAK"),
    $8bfd07244d38d92b$var$load("eS3wT"),
    $8bfd07244d38d92b$var$load("4uO8Y"),
    $8bfd07244d38d92b$var$load("60QcS"),
    $8bfd07244d38d92b$var$load("Wowvf"),
    $8bfd07244d38d92b$var$load("2l8zo"),
    $8bfd07244d38d92b$var$load("fEWss"),
    $8bfd07244d38d92b$var$load("ceGPg"),
    $8bfd07244d38d92b$var$load("26l7c"),
    $8bfd07244d38d92b$var$load("hhss7"),
    $8bfd07244d38d92b$var$load("cgKMu"),
    $8bfd07244d38d92b$var$load("lnKog"),
    $8bfd07244d38d92b$var$load("aAWLw"),
    $8bfd07244d38d92b$var$load("7EorR"),
    $8bfd07244d38d92b$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("h0PPQ", function(module, exports) {

let $c62aa5256a123966$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c62aa5256a123966$var$load("eS3wT"),
    $c62aa5256a123966$var$load("4uO8Y"),
    $c62aa5256a123966$var$load("hUbK8"),
    $c62aa5256a123966$var$load("2RkKX"),
    $c62aa5256a123966$var$load("1Gr4q"),
    $c62aa5256a123966$var$load("hLNtE"),
    $c62aa5256a123966$var$load("crwC4"),
    $c62aa5256a123966$var$load("7G12e"),
    $c62aa5256a123966$var$load("h4Nf7"),
    $c62aa5256a123966$var$load("123MJ"),
    $c62aa5256a123966$var$load("elQ9h"),
    $c62aa5256a123966$var$load("4XoWv"),
    $c62aa5256a123966$var$load("cFgVe"),
    $c62aa5256a123966$var$load("5wzAc"),
    $c62aa5256a123966$var$load("aLwQm"),
    $c62aa5256a123966$var$load("gBfQ7"),
    $c62aa5256a123966$var$load("eTvQu"),
    $c62aa5256a123966$var$load("kHXvF"),
    $c62aa5256a123966$var$load("ea3NB"),
    $c62aa5256a123966$var$load("kv4Kv"),
    $c62aa5256a123966$var$load("qCaIx"),
    $c62aa5256a123966$var$load("exBMi"),
    $c62aa5256a123966$var$load("6vqGz"),
    $c62aa5256a123966$var$load("iBJWz"),
    $c62aa5256a123966$var$load("cvcNg"),
    $c62aa5256a123966$var$load("iZR3N"),
    $c62aa5256a123966$var$load("jXM1T"),
    $c62aa5256a123966$var$load("6wr18"),
    $c62aa5256a123966$var$load("4N1MY"),
    $c62aa5256a123966$var$load("ffEVr"),
    $c62aa5256a123966$var$load("g81ly"),
    $c62aa5256a123966$var$load("e3LAK"),
    $c62aa5256a123966$var$load("cgKMu"),
    $c62aa5256a123966$var$load("60QcS"),
    $c62aa5256a123966$var$load("Wowvf"),
    $c62aa5256a123966$var$load("2l8zo"),
    $c62aa5256a123966$var$load("fEWss"),
    $c62aa5256a123966$var$load("ceGPg"),
    $c62aa5256a123966$var$load("26l7c"),
    $c62aa5256a123966$var$load("hhss7"),
    $c62aa5256a123966$var$load("aAWLw"),
    $c62aa5256a123966$var$load("7EorR"),
    $c62aa5256a123966$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("khyJi", function(module, exports) {

let $ec4055c2d9fb7f6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ec4055c2d9fb7f6e$var$load("eS3wT"),
    $ec4055c2d9fb7f6e$var$load("4uO8Y"),
    $ec4055c2d9fb7f6e$var$load("hUbK8"),
    $ec4055c2d9fb7f6e$var$load("2RkKX"),
    $ec4055c2d9fb7f6e$var$load("1Gr4q"),
    $ec4055c2d9fb7f6e$var$load("hLNtE"),
    $ec4055c2d9fb7f6e$var$load("crwC4"),
    $ec4055c2d9fb7f6e$var$load("7G12e"),
    $ec4055c2d9fb7f6e$var$load("h4Nf7"),
    $ec4055c2d9fb7f6e$var$load("123MJ"),
    $ec4055c2d9fb7f6e$var$load("elQ9h"),
    $ec4055c2d9fb7f6e$var$load("4XoWv"),
    $ec4055c2d9fb7f6e$var$load("cFgVe"),
    $ec4055c2d9fb7f6e$var$load("5wzAc"),
    $ec4055c2d9fb7f6e$var$load("aLwQm"),
    $ec4055c2d9fb7f6e$var$load("gBfQ7"),
    $ec4055c2d9fb7f6e$var$load("eTvQu"),
    $ec4055c2d9fb7f6e$var$load("kHXvF"),
    $ec4055c2d9fb7f6e$var$load("ea3NB"),
    $ec4055c2d9fb7f6e$var$load("kv4Kv"),
    $ec4055c2d9fb7f6e$var$load("qCaIx"),
    $ec4055c2d9fb7f6e$var$load("exBMi"),
    $ec4055c2d9fb7f6e$var$load("6vqGz"),
    $ec4055c2d9fb7f6e$var$load("iBJWz"),
    $ec4055c2d9fb7f6e$var$load("cvcNg"),
    $ec4055c2d9fb7f6e$var$load("iZR3N"),
    $ec4055c2d9fb7f6e$var$load("jXM1T"),
    $ec4055c2d9fb7f6e$var$load("6wr18"),
    $ec4055c2d9fb7f6e$var$load("4N1MY"),
    $ec4055c2d9fb7f6e$var$load("ffEVr"),
    $ec4055c2d9fb7f6e$var$load("g81ly"),
    $ec4055c2d9fb7f6e$var$load("e3LAK"),
    $ec4055c2d9fb7f6e$var$load("cgKMu"),
    $ec4055c2d9fb7f6e$var$load("60QcS"),
    $ec4055c2d9fb7f6e$var$load("Wowvf"),
    $ec4055c2d9fb7f6e$var$load("2l8zo"),
    $ec4055c2d9fb7f6e$var$load("fEWss"),
    $ec4055c2d9fb7f6e$var$load("ceGPg"),
    $ec4055c2d9fb7f6e$var$load("26l7c"),
    $ec4055c2d9fb7f6e$var$load("hhss7"),
    $ec4055c2d9fb7f6e$var$load("aAWLw"),
    $ec4055c2d9fb7f6e$var$load("7EorR"),
    $ec4055c2d9fb7f6e$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("aDqK1", function(module, exports) {

let $7be24a2a36b2dd0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7be24a2a36b2dd0b$var$load("eS3wT"),
    $7be24a2a36b2dd0b$var$load("4uO8Y"),
    $7be24a2a36b2dd0b$var$load("hUbK8"),
    $7be24a2a36b2dd0b$var$load("2RkKX"),
    $7be24a2a36b2dd0b$var$load("1Gr4q"),
    $7be24a2a36b2dd0b$var$load("hLNtE"),
    $7be24a2a36b2dd0b$var$load("crwC4"),
    $7be24a2a36b2dd0b$var$load("7G12e"),
    $7be24a2a36b2dd0b$var$load("h4Nf7"),
    $7be24a2a36b2dd0b$var$load("123MJ"),
    $7be24a2a36b2dd0b$var$load("elQ9h"),
    $7be24a2a36b2dd0b$var$load("4XoWv"),
    $7be24a2a36b2dd0b$var$load("cFgVe"),
    $7be24a2a36b2dd0b$var$load("5wzAc"),
    $7be24a2a36b2dd0b$var$load("aLwQm"),
    $7be24a2a36b2dd0b$var$load("gBfQ7"),
    $7be24a2a36b2dd0b$var$load("eTvQu"),
    $7be24a2a36b2dd0b$var$load("kHXvF"),
    $7be24a2a36b2dd0b$var$load("ea3NB"),
    $7be24a2a36b2dd0b$var$load("kv4Kv"),
    $7be24a2a36b2dd0b$var$load("qCaIx"),
    $7be24a2a36b2dd0b$var$load("exBMi"),
    $7be24a2a36b2dd0b$var$load("6vqGz"),
    $7be24a2a36b2dd0b$var$load("iBJWz"),
    $7be24a2a36b2dd0b$var$load("cvcNg"),
    $7be24a2a36b2dd0b$var$load("iZR3N"),
    $7be24a2a36b2dd0b$var$load("jXM1T"),
    $7be24a2a36b2dd0b$var$load("6wr18"),
    $7be24a2a36b2dd0b$var$load("4N1MY"),
    $7be24a2a36b2dd0b$var$load("ffEVr"),
    $7be24a2a36b2dd0b$var$load("g81ly"),
    $7be24a2a36b2dd0b$var$load("e3LAK"),
    $7be24a2a36b2dd0b$var$load("cgKMu"),
    $7be24a2a36b2dd0b$var$load("60QcS"),
    $7be24a2a36b2dd0b$var$load("Wowvf"),
    $7be24a2a36b2dd0b$var$load("2l8zo"),
    $7be24a2a36b2dd0b$var$load("fEWss"),
    $7be24a2a36b2dd0b$var$load("ceGPg"),
    $7be24a2a36b2dd0b$var$load("26l7c"),
    $7be24a2a36b2dd0b$var$load("hhss7"),
    $7be24a2a36b2dd0b$var$load("aAWLw"),
    $7be24a2a36b2dd0b$var$load("7EorR"),
    $7be24a2a36b2dd0b$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("5a0IY", function(module, exports) {

let $3c1e72c498fff006$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c1e72c498fff006$var$load("eS3wT"),
    $3c1e72c498fff006$var$load("4uO8Y"),
    $3c1e72c498fff006$var$load("hUbK8"),
    $3c1e72c498fff006$var$load("2RkKX"),
    $3c1e72c498fff006$var$load("1Gr4q"),
    $3c1e72c498fff006$var$load("hLNtE"),
    $3c1e72c498fff006$var$load("crwC4"),
    $3c1e72c498fff006$var$load("7G12e"),
    $3c1e72c498fff006$var$load("h4Nf7"),
    $3c1e72c498fff006$var$load("123MJ"),
    $3c1e72c498fff006$var$load("elQ9h"),
    $3c1e72c498fff006$var$load("4XoWv"),
    $3c1e72c498fff006$var$load("cFgVe"),
    $3c1e72c498fff006$var$load("5wzAc"),
    $3c1e72c498fff006$var$load("aLwQm"),
    $3c1e72c498fff006$var$load("gBfQ7"),
    $3c1e72c498fff006$var$load("eTvQu"),
    $3c1e72c498fff006$var$load("kHXvF"),
    $3c1e72c498fff006$var$load("ea3NB"),
    $3c1e72c498fff006$var$load("kv4Kv"),
    $3c1e72c498fff006$var$load("qCaIx"),
    $3c1e72c498fff006$var$load("exBMi"),
    $3c1e72c498fff006$var$load("6vqGz"),
    $3c1e72c498fff006$var$load("iBJWz"),
    $3c1e72c498fff006$var$load("cvcNg"),
    $3c1e72c498fff006$var$load("iZR3N"),
    $3c1e72c498fff006$var$load("jXM1T"),
    $3c1e72c498fff006$var$load("6wr18"),
    $3c1e72c498fff006$var$load("4N1MY"),
    $3c1e72c498fff006$var$load("ffEVr"),
    $3c1e72c498fff006$var$load("g81ly"),
    $3c1e72c498fff006$var$load("e3LAK"),
    $3c1e72c498fff006$var$load("60QcS"),
    $3c1e72c498fff006$var$load("Wowvf"),
    $3c1e72c498fff006$var$load("2l8zo"),
    $3c1e72c498fff006$var$load("fEWss"),
    $3c1e72c498fff006$var$load("ceGPg"),
    $3c1e72c498fff006$var$load("26l7c"),
    $3c1e72c498fff006$var$load("hhss7"),
    $3c1e72c498fff006$var$load("cgKMu"),
    $3c1e72c498fff006$var$load("lnKog"),
    $3c1e72c498fff006$var$load("aAWLw"),
    $3c1e72c498fff006$var$load("7EorR"),
    $3c1e72c498fff006$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("1udyT", function(module, exports) {

let $11531cdc96747f11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $11531cdc96747f11$var$load("hUbK8"),
    $11531cdc96747f11$var$load("2RkKX"),
    $11531cdc96747f11$var$load("dZsGY"),
    $11531cdc96747f11$var$load("1Gr4q"),
    $11531cdc96747f11$var$load("hLNtE"),
    $11531cdc96747f11$var$load("crwC4"),
    $11531cdc96747f11$var$load("7G12e"),
    $11531cdc96747f11$var$load("h4Nf7"),
    $11531cdc96747f11$var$load("123MJ"),
    $11531cdc96747f11$var$load("elQ9h"),
    $11531cdc96747f11$var$load("4XoWv"),
    $11531cdc96747f11$var$load("59hV4"),
    $11531cdc96747f11$var$load("cFgVe"),
    $11531cdc96747f11$var$load("5wzAc"),
    $11531cdc96747f11$var$load("aLwQm"),
    $11531cdc96747f11$var$load("gBfQ7"),
    $11531cdc96747f11$var$load("eTvQu"),
    $11531cdc96747f11$var$load("dr883"),
    $11531cdc96747f11$var$load("bePXd"),
    $11531cdc96747f11$var$load("kHXvF"),
    $11531cdc96747f11$var$load("ea3NB"),
    $11531cdc96747f11$var$load("kv4Kv"),
    $11531cdc96747f11$var$load("qCaIx"),
    $11531cdc96747f11$var$load("fuOfV"),
    $11531cdc96747f11$var$load("jL1Ke"),
    $11531cdc96747f11$var$load("5MQ0D"),
    $11531cdc96747f11$var$load("exBMi"),
    $11531cdc96747f11$var$load("6vqGz"),
    $11531cdc96747f11$var$load("iBJWz"),
    $11531cdc96747f11$var$load("cvcNg"),
    $11531cdc96747f11$var$load("iZR3N"),
    $11531cdc96747f11$var$load("jXM1T"),
    $11531cdc96747f11$var$load("6wr18"),
    $11531cdc96747f11$var$load("4N1MY"),
    $11531cdc96747f11$var$load("ffEVr"),
    $11531cdc96747f11$var$load("g81ly"),
    $11531cdc96747f11$var$load("e3LAK"),
    $11531cdc96747f11$var$load("eS3wT"),
    $11531cdc96747f11$var$load("4uO8Y"),
    $11531cdc96747f11$var$load("60QcS"),
    $11531cdc96747f11$var$load("Wowvf"),
    $11531cdc96747f11$var$load("2l8zo"),
    $11531cdc96747f11$var$load("fEWss"),
    $11531cdc96747f11$var$load("ceGPg"),
    $11531cdc96747f11$var$load("26l7c"),
    $11531cdc96747f11$var$load("hhss7"),
    $11531cdc96747f11$var$load("cgKMu"),
    $11531cdc96747f11$var$load("lnKog"),
    $11531cdc96747f11$var$load("aAWLw"),
    $11531cdc96747f11$var$load("7EorR"),
    $11531cdc96747f11$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2PFxD", function(module, exports) {

let $2100917232ee0414$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2100917232ee0414$var$load("hUbK8"),
    $2100917232ee0414$var$load("2RkKX"),
    $2100917232ee0414$var$load("dZsGY"),
    $2100917232ee0414$var$load("1Gr4q"),
    $2100917232ee0414$var$load("hLNtE"),
    $2100917232ee0414$var$load("crwC4"),
    $2100917232ee0414$var$load("7G12e"),
    $2100917232ee0414$var$load("h4Nf7"),
    $2100917232ee0414$var$load("123MJ"),
    $2100917232ee0414$var$load("elQ9h"),
    $2100917232ee0414$var$load("4XoWv"),
    $2100917232ee0414$var$load("59hV4"),
    $2100917232ee0414$var$load("cFgVe"),
    $2100917232ee0414$var$load("5wzAc"),
    $2100917232ee0414$var$load("aLwQm"),
    $2100917232ee0414$var$load("gBfQ7"),
    $2100917232ee0414$var$load("eTvQu"),
    $2100917232ee0414$var$load("dr883"),
    $2100917232ee0414$var$load("bePXd"),
    $2100917232ee0414$var$load("kHXvF"),
    $2100917232ee0414$var$load("ea3NB"),
    $2100917232ee0414$var$load("kv4Kv"),
    $2100917232ee0414$var$load("qCaIx"),
    $2100917232ee0414$var$load("fuOfV"),
    $2100917232ee0414$var$load("jL1Ke"),
    $2100917232ee0414$var$load("5MQ0D"),
    $2100917232ee0414$var$load("exBMi"),
    $2100917232ee0414$var$load("6vqGz"),
    $2100917232ee0414$var$load("iBJWz"),
    $2100917232ee0414$var$load("cvcNg"),
    $2100917232ee0414$var$load("iZR3N"),
    $2100917232ee0414$var$load("jXM1T"),
    $2100917232ee0414$var$load("6wr18"),
    $2100917232ee0414$var$load("4N1MY"),
    $2100917232ee0414$var$load("ffEVr"),
    $2100917232ee0414$var$load("g81ly"),
    $2100917232ee0414$var$load("e3LAK"),
    $2100917232ee0414$var$load("eS3wT"),
    $2100917232ee0414$var$load("4uO8Y"),
    $2100917232ee0414$var$load("60QcS"),
    $2100917232ee0414$var$load("Wowvf"),
    $2100917232ee0414$var$load("2l8zo"),
    $2100917232ee0414$var$load("fEWss"),
    $2100917232ee0414$var$load("ceGPg"),
    $2100917232ee0414$var$load("26l7c"),
    $2100917232ee0414$var$load("hhss7"),
    $2100917232ee0414$var$load("cgKMu"),
    $2100917232ee0414$var$load("lnKog"),
    $2100917232ee0414$var$load("aAWLw"),
    $2100917232ee0414$var$load("7EorR"),
    $2100917232ee0414$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("du0t7", function(module, exports) {

let $9d0e70c95e792d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d0e70c95e792d79$var$load("eS3wT"),
    $9d0e70c95e792d79$var$load("4uO8Y"),
    $9d0e70c95e792d79$var$load("hUbK8"),
    $9d0e70c95e792d79$var$load("2RkKX"),
    $9d0e70c95e792d79$var$load("1Gr4q"),
    $9d0e70c95e792d79$var$load("hLNtE"),
    $9d0e70c95e792d79$var$load("crwC4"),
    $9d0e70c95e792d79$var$load("7G12e"),
    $9d0e70c95e792d79$var$load("h4Nf7"),
    $9d0e70c95e792d79$var$load("123MJ"),
    $9d0e70c95e792d79$var$load("elQ9h"),
    $9d0e70c95e792d79$var$load("4XoWv"),
    $9d0e70c95e792d79$var$load("cFgVe"),
    $9d0e70c95e792d79$var$load("5wzAc"),
    $9d0e70c95e792d79$var$load("aLwQm"),
    $9d0e70c95e792d79$var$load("gBfQ7"),
    $9d0e70c95e792d79$var$load("eTvQu"),
    $9d0e70c95e792d79$var$load("kHXvF"),
    $9d0e70c95e792d79$var$load("ea3NB"),
    $9d0e70c95e792d79$var$load("kv4Kv"),
    $9d0e70c95e792d79$var$load("qCaIx"),
    $9d0e70c95e792d79$var$load("exBMi"),
    $9d0e70c95e792d79$var$load("6vqGz"),
    $9d0e70c95e792d79$var$load("iBJWz"),
    $9d0e70c95e792d79$var$load("cvcNg"),
    $9d0e70c95e792d79$var$load("iZR3N"),
    $9d0e70c95e792d79$var$load("jXM1T"),
    $9d0e70c95e792d79$var$load("6wr18"),
    $9d0e70c95e792d79$var$load("4N1MY"),
    $9d0e70c95e792d79$var$load("ffEVr"),
    $9d0e70c95e792d79$var$load("g81ly"),
    $9d0e70c95e792d79$var$load("e3LAK"),
    $9d0e70c95e792d79$var$load("cgKMu"),
    $9d0e70c95e792d79$var$load("60QcS"),
    $9d0e70c95e792d79$var$load("Wowvf"),
    $9d0e70c95e792d79$var$load("2l8zo"),
    $9d0e70c95e792d79$var$load("fEWss"),
    $9d0e70c95e792d79$var$load("ceGPg"),
    $9d0e70c95e792d79$var$load("26l7c"),
    $9d0e70c95e792d79$var$load("hhss7"),
    $9d0e70c95e792d79$var$load("aAWLw"),
    $9d0e70c95e792d79$var$load("7EorR"),
    $9d0e70c95e792d79$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("jBfC3", function(module, exports) {

let $e44d956a24bfe607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e44d956a24bfe607$var$load("eS3wT"),
    $e44d956a24bfe607$var$load("4uO8Y"),
    $e44d956a24bfe607$var$load("hUbK8"),
    $e44d956a24bfe607$var$load("2RkKX"),
    $e44d956a24bfe607$var$load("1Gr4q"),
    $e44d956a24bfe607$var$load("hLNtE"),
    $e44d956a24bfe607$var$load("crwC4"),
    $e44d956a24bfe607$var$load("7G12e"),
    $e44d956a24bfe607$var$load("h4Nf7"),
    $e44d956a24bfe607$var$load("123MJ"),
    $e44d956a24bfe607$var$load("elQ9h"),
    $e44d956a24bfe607$var$load("4XoWv"),
    $e44d956a24bfe607$var$load("cFgVe"),
    $e44d956a24bfe607$var$load("5wzAc"),
    $e44d956a24bfe607$var$load("aLwQm"),
    $e44d956a24bfe607$var$load("gBfQ7"),
    $e44d956a24bfe607$var$load("eTvQu"),
    $e44d956a24bfe607$var$load("kHXvF"),
    $e44d956a24bfe607$var$load("ea3NB"),
    $e44d956a24bfe607$var$load("kv4Kv"),
    $e44d956a24bfe607$var$load("qCaIx"),
    $e44d956a24bfe607$var$load("exBMi"),
    $e44d956a24bfe607$var$load("6vqGz"),
    $e44d956a24bfe607$var$load("iBJWz"),
    $e44d956a24bfe607$var$load("cvcNg"),
    $e44d956a24bfe607$var$load("iZR3N"),
    $e44d956a24bfe607$var$load("jXM1T"),
    $e44d956a24bfe607$var$load("6wr18"),
    $e44d956a24bfe607$var$load("4N1MY"),
    $e44d956a24bfe607$var$load("ffEVr"),
    $e44d956a24bfe607$var$load("g81ly"),
    $e44d956a24bfe607$var$load("e3LAK"),
    $e44d956a24bfe607$var$load("60QcS"),
    $e44d956a24bfe607$var$load("Wowvf"),
    $e44d956a24bfe607$var$load("2l8zo"),
    $e44d956a24bfe607$var$load("fEWss"),
    $e44d956a24bfe607$var$load("ceGPg"),
    $e44d956a24bfe607$var$load("26l7c"),
    $e44d956a24bfe607$var$load("hhss7"),
    $e44d956a24bfe607$var$load("cgKMu"),
    $e44d956a24bfe607$var$load("lnKog"),
    $e44d956a24bfe607$var$load("aAWLw"),
    $e44d956a24bfe607$var$load("7EorR"),
    $e44d956a24bfe607$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("bydAg", function(module, exports) {

let $868d682de9ef0645$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $868d682de9ef0645$var$load("eS3wT"),
    $868d682de9ef0645$var$load("4uO8Y"),
    $868d682de9ef0645$var$load("hUbK8"),
    $868d682de9ef0645$var$load("2RkKX"),
    $868d682de9ef0645$var$load("1Gr4q"),
    $868d682de9ef0645$var$load("hLNtE"),
    $868d682de9ef0645$var$load("crwC4"),
    $868d682de9ef0645$var$load("7G12e"),
    $868d682de9ef0645$var$load("h4Nf7"),
    $868d682de9ef0645$var$load("123MJ"),
    $868d682de9ef0645$var$load("elQ9h"),
    $868d682de9ef0645$var$load("4XoWv"),
    $868d682de9ef0645$var$load("cFgVe"),
    $868d682de9ef0645$var$load("5wzAc"),
    $868d682de9ef0645$var$load("aLwQm"),
    $868d682de9ef0645$var$load("gBfQ7"),
    $868d682de9ef0645$var$load("eTvQu"),
    $868d682de9ef0645$var$load("kHXvF"),
    $868d682de9ef0645$var$load("ea3NB"),
    $868d682de9ef0645$var$load("kv4Kv"),
    $868d682de9ef0645$var$load("qCaIx"),
    $868d682de9ef0645$var$load("exBMi"),
    $868d682de9ef0645$var$load("6vqGz"),
    $868d682de9ef0645$var$load("iBJWz"),
    $868d682de9ef0645$var$load("cvcNg"),
    $868d682de9ef0645$var$load("iZR3N"),
    $868d682de9ef0645$var$load("jXM1T"),
    $868d682de9ef0645$var$load("6wr18"),
    $868d682de9ef0645$var$load("4N1MY"),
    $868d682de9ef0645$var$load("ffEVr"),
    $868d682de9ef0645$var$load("g81ly"),
    $868d682de9ef0645$var$load("e3LAK"),
    $868d682de9ef0645$var$load("60QcS"),
    $868d682de9ef0645$var$load("Wowvf"),
    $868d682de9ef0645$var$load("2l8zo"),
    $868d682de9ef0645$var$load("fEWss"),
    $868d682de9ef0645$var$load("ceGPg"),
    $868d682de9ef0645$var$load("26l7c"),
    $868d682de9ef0645$var$load("hhss7"),
    $868d682de9ef0645$var$load("cgKMu"),
    $868d682de9ef0645$var$load("lnKog"),
    $868d682de9ef0645$var$load("aAWLw"),
    $868d682de9ef0645$var$load("7EorR"),
    $868d682de9ef0645$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== moduleType) {
        t3 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[0] = moduleType;
        $[1] = t3;
    } else t3 = $[1];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t3);
    let t4;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== locale || $[5] !== moduleType || $[6] !== queryOptions || $[7] !== resolvedAttachmentId || $[8] !== returnBlockedExtensions || $[9] !== skipQuery || $[10] !== spaceContextOnly || $[11] !== spaceKey) {
        t4 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = locale;
        $[5] = moduleType;
        $[6] = queryOptions;
        $[7] = resolvedAttachmentId;
        $[8] = returnBlockedExtensions;
        $[9] = skipQuery;
        $[10] = spaceContextOnly;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    const options = t4;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t5;
    let t6;
    if ($[13] !== extsError || $[14] !== spaceError) {
        t5 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t6 = [
            extsError,
            spaceError
        ];
        $[13] = extsError;
        $[14] = spaceError;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)("confluence_space_apps_ssr_preload")) {
        let t7;
        if ($[17] !== ssrExtensionResult.error || $[18] !== ssrExtensionResult.extensions) {
            t7 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[17] = ssrExtensionResult.error;
            $[18] = ssrExtensionResult.extensions;
            $[19] = t7;
        } else t7 = $[19];
        return t7;
    }
    let t7;
    if ($[20] !== extsData || $[21] !== extsError || $[22] !== extsLoading) {
        t7 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[20] = extsData;
        $[21] = extsError;
        $[22] = extsLoading;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)('confluence_space_apps_ssr_preload')) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            // Instrument the presence of non-content 3P connect apps so their keys
            // are folded into the page-load `connectAppKeys` telemetry.
            if ((0, $9wGTI.fg)('cc_record_non_content_macros')) (0, $8wW9d.recordNonContentAppKeys)('web-item', formattedWebItems.map((webItem)=>webItem.completeKey));
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _2gHOcPzXzM _1DH08Qjg0e _20DmKqEqul _14Wx5PeKmV _2qRYQF98eZ _0oQUy6YbGa _0tUIKU6wH8 _0WfKEq2Njc _1UNQhUvbI6 _2UvIvUOLYo _1KE8vRbllS _3cgr8TQame _3uAMeFLRg7 _2LESMOvbI6 _0k3IULDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $kNIYN.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");


var $jX1qB = parcelRequire("jX1qB");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("gqypm", function(module, exports) {

var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ skip: skip, fetchPolicy: fetchPolicy })=>{
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip,
        fetchPolicy: fetchPolicy
    });
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("gektR", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleError = (0, $cozmU.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $cozmU.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $cozmU.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: cacheData,
                                __callerPackage__: "content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("2MwVI", function(module, exports) {

var $635s2 = parcelRequire("635s2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $gsf3i = parcelRequire("gsf3i");

const $49bfbfa6f9c85bf2$export$ea561d273e8cda71 = "\u2588\u2588\u2588\u2588";
const $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN = /██\s*\[ID:[^\]]+\]/u;
const $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString = (title)=>Boolean(title && $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN.test(title));
const $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString = (title)=>Boolean(title && title.includes($49bfbfa6f9c85bf2$export$ea561d273e8cda71));
const $49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1 = (title)=>{
    return $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title) || $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title);
};
const $49bfbfa6f9c85bf2$export$19187316a5e6c180 = ({ contentId: contentId, title: title })=>{
    const { clearTitleRedactionRenderedForContentId: clearTitleRedactionRenderedForContentId, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId } = (0, $gsf3i.useRedactionsTourActions)();
    const titleHasCurrentRedaction = (0, $cozmU.useMemo)(()=>$49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title), [
        title
    ]);
    const titleMaybeHasLegacyRedaction = (0, $cozmU.useMemo)(()=>!titleHasCurrentRedaction && $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title), [
        title,
        titleHasCurrentRedaction
    ]);
    const { data: data, error: redactionsCountError } = (0, $jMyy4.useQueryInterop)((0, $635s2.default), {
        skip: !titleMaybeHasLegacyRedaction,
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all',
        __callerPackage__: "redactions"
    });
    // handle 4xx errors
    (0, $cozmU.useEffect)(()=>{
        if (redactionsCountError && (0, $aMcHK.isStatusCodeError)(redactionsCountError, '404')) (0, $7Sm4c.markErrorAsHandled)(redactionsCountError);
    }, [
        redactionsCountError
    ]);
    const redactionsCount = data?.singleContent?.redactionMetadataCount ?? 0;
    const isTitleRedactionConfirmed = titleHasCurrentRedaction || titleMaybeHasLegacyRedaction && redactionsCount > 0;
    (0, $cozmU.useEffect)(()=>{
        if (contentId && isTitleRedactionConfirmed) setTitleRedactionRenderedForContentId(contentId);
        return ()=>{
            clearTitleRedactionRenderedForContentId(contentId);
        };
    }, [
        clearTitleRedactionRenderedForContentId,
        contentId,
        isTitleRedactionConfirmed,
        setTitleRedactionRenderedForContentId
    ]);
};
module.exports["useTrackTitleRedactionRendered"] = $49bfbfa6f9c85bf2$export$19187316a5e6c180;

});

parcelRegister("635s2", function(module, exports) {
/**
 * @generated SignedSource<<a0a12f229cf3db623a511192bab87885>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9
const $a51c9ec4f18af0fc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2231280d1a64c0467ba87a246116380",
            "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
            "metadata": {},
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "operationKind": "query",
            "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$a51c9ec4f18af0fc$var$node.hash = "f9a742b4e2840cd061fc6915ae9b6b93";
var $a51c9ec4f18af0fc$export$2e2bcd8739ae039 = $a51c9ec4f18af0fc$var$node;
module.exports["default"] = $a51c9ec4f18af0fc$export$2e2bcd8739ae039;

});

parcelRegister("80koo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $cozmU.useState)({
        loaded: false,
        modules: []
    });
    (0, $cozmU.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("3BmH5", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $b13a5e685a63e41e$export$1813df84621a6710 = (properties)=>{
    const devDocsProperties = (0, $6rBRz.getDevDocsProperties)(properties);
    const smartFolderProperties = (0, $6rBRz.getDevDocsSmartFolderProperties)(properties);
    return {
        containerApp: smartFolderProperties?.containerApp ?? null,
        devDocsProperties: devDocsProperties,
        smartFolderProperties: smartFolderProperties
    };
};
module.exports["getDevDocsFolderMetadata"] = $b13a5e685a63e41e$export$1813df84621a6710;

});

parcelRegister("6rBRz", function(module, exports) {
const $7f56be30e613d57d$export$717f665ef6ce5e67 = 'devdocsProperties';
const $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $7f56be30e613d57d$var$parseContentPropertyValue = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) return null;
            const value = parsedValue.value;
            if (typeof value === 'string' || value && typeof value === 'object') {
                parsedValue = value;
                continue;
            }
            return parsedValue;
        }
    } catch  {
        return null;
    }
    return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : null;
};
const $7f56be30e613d57d$var$getStringValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return typeof value === 'string' && value.length > 0 ? value : null;
};
const $7f56be30e613d57d$var$getBooleanValue = (parsedValue, key)=>parsedValue[key] === true;
const $7f56be30e613d57d$var$getObjectValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
};
const $7f56be30e613d57d$export$48d1088454f9afc1 = (properties)=>{
    const devDocsProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67);
    const parsedValue = devDocsProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(devDocsProperties.value) : null;
    return parsedValue ? {
        customPrompt: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'customPrompt'),
        ref: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'ref'),
        repoName: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'repoName'),
        syncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncTaskAri')
    } : null;
};
const $7f56be30e613d57d$export$8cfd9e7aae7c88a3 = (properties)=>Boolean(properties?.some((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67));
const $7f56be30e613d57d$export$a9f33e9d1e3524ad = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY);
    const parsedValue = smartFolderProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(smartFolderProperties.value) : null;
    return parsedValue ? {
        containerApp: $7f56be30e613d57d$var$getStringValue(parsedValue, 'containerApp'),
        lastSynced: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSynced'),
        lastSyncAttemptedAt: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncAttemptedAt'),
        lastSyncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncTaskAri'),
        syncErrorType: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncErrorType'),
        syncInProgress: $7f56be30e613d57d$var$getBooleanValue(parsedValue, 'syncInProgress')
    } : null;
};
module.exports["getDevDocsProperties"] = $7f56be30e613d57d$export$48d1088454f9afc1;
module.exports["hasDevDocsContentProperty"] = $7f56be30e613d57d$export$8cfd9e7aae7c88a3;
module.exports["getDevDocsSmartFolderProperties"] = $7f56be30e613d57d$export$a9f33e9d1e3524ad;

});

parcelRegister("i1PdO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $aboIx = parcelRequire("aboIx");

const $294e9e08bc7d2598$var$getPropertyCollections = ({ contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties })=>[
        ...propertyCollections ?? [],
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        smartFolderProperties
    ];
const $294e9e08bc7d2598$export$acc7106896b1bce2 = (sources)=>{
    const { contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties } = sources;
    const isDevDocsEnabled = (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs');
    const isDevDocsOwned = (0, $cozmU.useMemo)(()=>(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: $294e9e08bc7d2598$var$getPropertyCollections({
                contentProperties: contentProperties,
                devDocsOwnershipProperties: devDocsOwnershipProperties,
                devDocsProperties: devDocsProperties,
                propertyCollections: propertyCollections,
                smartFolderProperties: smartFolderProperties
            })
        }), [
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        propertyCollections,
        smartFolderProperties
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isDevDocsEnabled: isDevDocsEnabled,
            isDevDocsEligible: isDevDocsEnabled && isDevDocsOwned,
            isDevDocsOwned: isDevDocsOwned
        }), [
        isDevDocsEnabled,
        isDevDocsOwned
    ]);
};
module.exports["useDevDocsFolderEligibility"] = $294e9e08bc7d2598$export$acc7106896b1bce2;

});

parcelRegister("aboIx", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS = new Set([
    'bitbucket',
    'github'
]);
const $95f2a41306aaddc5$var$isDevDocsContainerApp = (containerApp)=>Boolean(containerApp && $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS.has(containerApp.trim().toLowerCase()));
const $95f2a41306aaddc5$export$270f9eb55072514a = ({ propertyCollections: propertyCollections = [] })=>{
    if (propertyCollections.some((properties)=>(0, $6rBRz.hasDevDocsContentProperty)(properties))) return true;
    return propertyCollections.some((properties)=>$95f2a41306aaddc5$var$isDevDocsContainerApp((0, $6rBRz.getDevDocsSmartFolderProperties)(properties)?.containerApp));
};
const $95f2a41306aaddc5$export$4977c1f16ed3f03f = ({ ownershipProperties: ownershipProperties, smartFolderProperties: smartFolderProperties })=>$95f2a41306aaddc5$export$270f9eb55072514a({
        propertyCollections: [
            ownershipProperties,
            smartFolderProperties
        ]
    });
module.exports["isDevDocsOwnedFolder"] = $95f2a41306aaddc5$export$270f9eb55072514a;
module.exports["shouldExcludeDevDocsAutoSync"] = $95f2a41306aaddc5$export$4977c1f16ed3f03f;

});

parcelRegister("fZLJ8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3BmH5 = parcelRequire("3BmH5");


var $i1PdO = parcelRequire("i1PdO");


var $aboIx = parcelRequire("aboIx");

const $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE = 'managed';
const $050967cdd11104af$var$isManagedFolderAncestor = (ancestor)=>ancestor?.type?.toLowerCase() === 'folder' && ancestor?.subType?.toLowerCase() === $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE;
const $050967cdd11104af$var$getCreatedByDisplayName = (ancestor)=>{
    const displayName = ancestor?.['history']?.createdBy?.displayName?.trim();
    return displayName || null;
};
const $050967cdd11104af$export$b792028224cde203 = (ancestors)=>{
    const managedDevDocsAncestor = ancestors?.find((ancestor)=>{
        if (!$050967cdd11104af$var$isManagedFolderAncestor(ancestor)) return false;
        if (!(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: [
                ancestor?.properties?.nodes
            ]
        })) return false;
        return Boolean((0, $3BmH5.getDevDocsFolderMetadata)(ancestor?.properties?.nodes).devDocsProperties?.repoName);
    });
    const folderMetadata = (0, $3BmH5.getDevDocsFolderMetadata)(managedDevDocsAncestor?.properties?.nodes);
    const repoName = folderMetadata.devDocsProperties?.repoName;
    const folderId = managedDevDocsAncestor?.id;
    if (!repoName || !folderId) return null;
    return {
        folderId: folderId,
        folderWebui: managedDevDocsAncestor?.links?.webui ?? null,
        repoName: repoName,
        provider: folderMetadata.containerApp,
        owner: $050967cdd11104af$var$getCreatedByDisplayName(managedDevDocsAncestor),
        lastSynced: folderMetadata.smartFolderProperties?.lastSynced ?? null
    };
};
const $050967cdd11104af$export$1e19ef9187efb6c7 = (ancestors)=>{
    const ancestorPropertyCollections = (0, $cozmU.useMemo)(()=>ancestors?.map((ancestor)=>ancestor?.properties?.nodes) ?? [], [
        ancestors
    ]);
    const { isDevDocsEligible: isDevDocsEligible } = (0, $i1PdO.useDevDocsFolderEligibility)({
        propertyCollections: ancestorPropertyCollections
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!isDevDocsEligible) return null;
        return $050967cdd11104af$export$b792028224cde203(ancestors);
    }, [
        ancestors,
        isDevDocsEligible
    ]);
};
module.exports["getDevDocsConnectionFromAncestors"] = $050967cdd11104af$export$b792028224cde203;
module.exports["useDevDocsBylineConnection"] = $050967cdd11104af$export$1e19ef9187efb6c7;

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), {
        ...baseQueryOptions,
        __callerPackage__: "web-item-location"
    });
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)("web-item", webItems.map($f64809aa9d8f3ca2$var$_temp2));
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
function $f64809aa9d8f3ca2$var$_temp2(webItem_0) {
    return webItem_0.completeKey;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});


//# sourceMappingURL=EditorByLineArea.558e32aa.js.map
